import type { ApolloClient } from '@apollo/client';
import type React from 'react';
import { createContext, useContext } from 'react';

type ApolloClientState = Record<string, ApolloClient>;

const defaultState: ApolloClientState = {};

export const ApolloClientContext = createContext<ApolloClientState>(defaultState);

type ApolloClientContextContainerProps = {
  children: React.ReactNode;
  clients: ApolloClientState;
};

export const ApolloClientContextContainer: React.FC<ApolloClientContextContainerProps> = ({ children, clients }) => {
  return <ApolloClientContext.Provider value={clients}>{children}</ApolloClientContext.Provider>;
};

export const useClients = () => {
  return useContext(ApolloClientContext);
};
